module.exports = __webpack_public_path__ + "img/B.d0929c08.png";